import React, { useContext ,useState} from "react";

import Button from "@mui/material/Button";
import { multiStepContext } from "../StepContext";
import secondSteps from "../Style/SecondStep.css";

import arcade from '../images/icon-arcade.svg'
import advanced from '../images/icon-advanced.svg'
import pro from '../images/icon-pro.svg'
import Form from "react-bootstrap/Form";




const SecondStep = () => {
  const { setCurrentStep, setUserData, userData } =
    useContext(multiStepContext);
 
 


  const price1 = 10;
  const name1 = "Arcade";
  const price2 = 20;
  const name2 = "Advanced";
  const price3 = 30;
  const name3 = "Pro";

  return (
    <div className="">
      <div className="section1 personalInfosection">
        <h2>Personal info</h2>
        <p>Please provide your name, email address, and phone number .</p>
      </div>







<div className="cardSection " >

      <div
        onClick={(e) => setUserData({ ...userData, price1, name1 , })}
        value={userData[price1]}
        className="card1"
      >
        <div className="logo">
          <img src={arcade} />
        </div>
        <h5>{name1}</h5>
        <p>${price1}/mo</p>
      </div>

      <div
        onClick={(e) => setUserData({ ...userData, price2, name2 })}
        value={userData[price2]}
        className="card1"
      >
        <div className="logo">
        <img src={advanced} />
        </div>
        <h5>{name2}</h5>
        <p>${price2}/mo</p>
      </div>

      <div
        onClick={(e) => setUserData({ ...userData, price3, name3 })}
        value={userData[price3]}
        className="card1"
      >
        <div className="logo">
        <img src={pro} />
        </div>
        <h5>{name3}</h5>
        <p>${price3}/mo</p>
      </div>
</div>

<div className="section3">
          <p>Monthly</p>
          <Form>
            <Form.Check type="switch" id="custom-switch" label="" />
          </Form>
          <p>Yearly</p>
        </div>

<div className="btngroup">

<div className="">

      <button
        className="btn1"
        style={{ marginRight: "10px" }}
        onClick={() => setCurrentStep(1)}
        variant="contained"
        color="primary"
      >
        Back
      </button>
</div>
<div className="">

      <button
        className="nextBtn "
        onClick={() => setCurrentStep(3)}
        variant="contained"
        color="primary"
      >
        Next
      </button>
</div>
    </div>
    </div>
  );
};

export default SecondStep;
